import { Badge, Stack } from "@mui/material";
import React from "react";
import Swal from "sweetalert2";
import portalpaymentlink from "../../../services/portalpaymentlink";

const GSTAmountFormatter = ({ cell, row }) => {
    const customFontStyle = {
        fontSize: 10,
        fontfamily: "Quicksand"
    };

    const handleGstPay = async (id) => {
        const { value: file } = await Swal.fire({
            title: "Select File to Upload",
            input: "file",
            inputAttributes: {
                accept: "pdf/*",
                required: true,
                "aria-label": "Upload GST File"
            },
        });

        if (file) {
            const reader = new FileReader();
            reader.onload = (e) => {
                Swal.fire({
                    title: "Your Uploaded File",
                    imageUrl: e.target.result,
                    imageAlt: "The Uploaded File",
                });
            };
            reader.readAsDataURL(file);
            const formData = new FormData();
            formData.append("file", file);
            formData.append("id", id);
            formData.append("campaign", row.campaign._id);

            if (row.isCompany) formData.append("name", row.company._id);
            else formData.append("name", row.influencer._id);

            formData.append("isCompany", row.isCompany);

            await portalpaymentlink.uploadFile(formData, "paygst");
        }
    };

    return cell ? (
        <Stack
            rowGap={0.5}
            alignItems={'center'}
        >
            <Badge
                sx={{
                    bgcolor: row.isGstPay ? "#198754" : "#FFC107",
                    color: row.isGstPay ? "#FFFFFF" : "#000000",
                    padding: "4px 8px",
                    borderRadius: "4px",
                    fontWeight: 500,
                    ...customFontStyle
                }}
            >
                {`\u20B9${cell}`}
            </Badge>

            {row.gstAmount &&
                row.status === "S" &&
                !row.isGstPay &&
                !row.isGstRequested ? (
                <Badge
                    type="button"
                    title="Pay GST"
                    className="btn btn-primary fw-bold p-1 mt-1"
                    onClick={() => handleGstPay(row._id)}
                    sx={{
                        ...customFontStyle,
                        bgcolor: "#0D6EFD",
                        color: "#FFFFFF",
                        padding: "4px 8px",
                        borderRadius: "4px",
                        cursor: "pointer"
                    }}
                >
                    Pay GST
                </Badge>
            ) : (
                ""
            )}
        </Stack>
    ) : (
        <span style={customFontStyle}></span>
    );
};

export default GSTAmountFormatter;